export const END_CALL_EVENTS = {
    END_CALL: "END_CALL",
    RESET_END_CALL: "RESET_END_CALL",
};

export const END_CALL = {
    START: "END_CALL_START",
    SUCCESS: "END_CALL_SUCCESS",
    ERROR: "END_CALL_ERROR",
};

const defaultEndCallState = {
    endCallError: false,
    endCallData: false,
    endCallLoading: false,
};

export const defaultState = {
    ...defaultEndCallState,
};

const endCallReducer = (state = defaultState, action = {}) => {
    switch (action.event) {
        case END_CALL_EVENTS.END_CALL:
            return {
                ...state,
                endCallLoading: action.type === END_CALL.START,
                endCallData: action.type === END_CALL.SUCCESS ? action.payload : false,
                endCallError: action.type === END_CALL.ERROR ? action.payload : false,
            };
        case END_CALL_EVENTS.RESET_END_CALL:
            return defaultState;
        default:
            return state;
    }
};

export default endCallReducer;
